import { render, staticRenderFns } from "./TeamGeneralMuscleSorenessTrendChart.vue?vue&type=template&id=5dd69274"
import script from "./TeamGeneralMuscleSorenessTrendChart.vue?vue&type=script&lang=js"
export * from "./TeamGeneralMuscleSorenessTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports